import React, { useState } from 'react';
import { Paper, Button, Grid, Switch, FormControlLabel, Divider } from '@mui/material';
import Sidebar from '../Sidebar/Sidebar';
import './Admin.css';

const Admin: React.FC = () => {
    // States for toggles
    const [darkMode, setDarkMode] = useState(false);
    const [emailNotifications, setEmailNotifications] = useState(true);
    const [smsNotifications, setSmsNotifications] = useState(false);
    const [autoUpdate, setAutoUpdate] = useState(true);

    return (
        <div style={{ display: 'flex' }}>
            <Sidebar />
            <Paper sx={{ padding: '48px', minWidth: 'calc(100% - 130px)' }}>
                <h2>
                    Admin Panel
                </h2>
                <span>
                    This is the admin panel where you can manage settings and notifications.
                </span>

                <Grid container spacing={4} sx={{ marginTop: '24px' }}>
                    {/* Settings Management */}
                    <Grid item xs={12}>
                        <h4>System Settings</h4>
                        <Divider sx={{ marginBottom: '16px' }} />
                        
                        {/* Dark Mode Toggle */}
                        <FormControlLabel
                            control={<Switch checked={darkMode} onChange={() => setDarkMode(!darkMode)} />}
                            label="Enable Dark Mode"
                        />

                        {/* Auto-Update Toggle */}
                        <FormControlLabel
                            control={<Switch checked={autoUpdate} onChange={() => setAutoUpdate(!autoUpdate)} />}
                            label="Enable Automatic Updates"
                        />

                        <Button
                            variant="contained"
                            sx={{ backgroundColor: 'primary.light' }}
                        >
                            Save Changes
                        </Button>
                    </Grid>

                    {/* Notification Settings */}
                    <Grid item xs={12}>
                        <h4>Notification Preferences</h4>
                        <Divider sx={{ marginBottom: '16px' }} />

                        {/* Email Notifications Toggle */}
                        <FormControlLabel
                            control={<Switch checked={emailNotifications} onChange={() => setEmailNotifications(!emailNotifications)} />}
                            label="Email Notifications"
                        />

                        {/* SMS Notifications Toggle */}
                        <FormControlLabel
                            control={<Switch checked={smsNotifications} onChange={() => setSmsNotifications(!smsNotifications)} />}
                            label="SMS Notifications"
                        />

                        <Button variant="contained" sx={{ marginTop: '16px', backgroundColor: 'primary.light' }}>
                            Save Notification Settings
                        </Button>
                    </Grid>

                    {/* Simulated Other Features */}
                    <Grid item xs={12}>
                        <h4>Other Features</h4>
                        <span>Additional admin functionalities can be added here.</span>
                    </Grid>
                </Grid>
            </Paper>
        </div>
    );
};

export default Admin;
